import BaseModel from './base'


export const schema = {
  id: undefined,
  menu_id: undefined,
  name: '',
  description: '',
  price: 0,
  created_at: undefined,
  updated_at: undefined,
  images_count: 0,
  is_enabled: false,
  reviews_count: 0,
  ingredients_text: '',
  rating: 0,
  is_approved: false,
  comments: '',
  is_pending: false,
  packaging: '',
  quantity_per_pkg: 0,
  meal_type: '',
  serving_utensil: '',
  is_sub_menu_item: false,
  sub_menu_item_category: '',
  parent_menu_item_id: undefined,
  get_sub_menu_categories: [],
  tags_dietary_preference_list: '',
  tags_ingredient_list: '',

  chef_id: undefined,
  chef_name: undefined,
  chef_first_name: undefined,
  chef_last_name: undefined,

  sold_quantity: undefined,
  offering_quantity: undefined,

  images: [],
  ingredients_image: undefined,
  child_menu_items: [],

  scheduled_offerings: [],
  reviews: [],

  orders: [],
  parent_menu_item_name: undefined,
}


export default class MenuItem extends BaseModel ( schema ) {
  static create( json = {}) {
    return new MenuItem( json )
  }
}
